// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface Upgrade {
  id: string;
  name: string;
  description: string;
  icon: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  apply: (player: any) => void;
}

export const UPGRADE_POOL: Upgrade[] = [
  {
    id: 'damage_up',
    name: 'Power Shot',
    description: '+20% projectile damage',
    icon: '💥',
    apply: (p) => { p.damage = Math.round(p.damage * 1.2); },
  },
  {
    id: 'fire_rate_up',
    name: 'Rapid Fire',
    description: '+25% fire rate',
    icon: '🔥',
    apply: (p) => { p.fireRate = Math.round(p.fireRate * 0.75); },
  },
  {
    id: 'extra_projectile',
    name: 'Multi-Shot',
    description: 'Fire an additional projectile per shot',
    icon: '🎯',
    apply: (p) => { p.projectileCount = (p.projectileCount || 1) + 1; },
  },
  {
    id: 'move_speed_up',
    name: 'Speed Boost',
    description: '+15% movement speed',
    icon: '⚡',
    apply: (p) => { p.speed = Math.round(p.speed * 1.15); },
  },
  {
    id: 'max_hp_up',
    name: 'Reinforced Armor',
    description: '+30 max HP, restore 15 HP',
    icon: '🛡️',
    apply: (p) => { p.maxHp += 30; p.hp = Math.min(p.hp + 15, p.maxHp); },
  },
  {
    id: 'pickup_radius_up',
    name: 'Magnetism',
    description: '+50% XP pickup radius',
    icon: '🧲',
    apply: (p) => { p.pickupRadius = Math.round(p.pickupRadius * 1.5); },
  },
  {
    id: 'hp_regen',
    name: 'Regeneration',
    description: 'Passively regenerate 2 HP/sec',
    icon: '💚',
    apply: (p) => { p.hpRegen = (p.hpRegen || 0) + 2; },
  },
  {
    id: 'armor_piercing',
    name: 'Armor Piercing',
    description: '+35% projectile damage',
    icon: '🔱',
    apply: (p) => { p.damage = Math.round(p.damage * 1.35); },
  },
  {
    id: 'velocity_rounds',
    name: 'Velocity Rounds',
    description: '+40% projectile speed',
    icon: '🚀',
    apply: (p) => { p.projectileSpeed = Math.round((p.projectileSpeed || 500) * 1.4); },
  },
  {
    id: 'overcharge',
    name: 'Overcharge',
    description: '+40% fire rate',
    icon: '⚡',
    apply: (p) => { p.fireRate = Math.round(p.fireRate * 0.6); },
  },
  {
    id: 'adrenaline',
    name: 'Adrenaline Rush',
    description: '+25% movement speed',
    icon: '💨',
    apply: (p) => { p.speed = Math.round(p.speed * 1.25); },
  },
  {
    id: 'lifesteal',
    name: 'Life Drain',
    description: 'Restore 5 HP per kill',
    icon: '🩸',
    apply: (p) => { p.lifesteal = (p.lifesteal || 0) + 5; },
  },
  {
    id: 'shield_burst',
    name: 'Emergency Shield',
    description: 'Restore 25 HP immediately',
    icon: '❤️',
    apply: (p) => { p.hp = Math.min((p.hp || 0) + 25, p.maxHp); },
  },
];

export class UpgradeSystem {
  private selectedIds: Set<string> = new Set();

  getRandomUpgrades(count: number): Upgrade[] {
    // Always pick random upgrades from the full pool, allowing duplicates.
    // This enables stacking upgrades (e.g., multiple extra projectiles).
    return this.shuffle([...UPGRADE_POOL]).slice(0, count);
  }

  markSelected(upgradeId: string) {
    this.selectedIds.add(upgradeId);
  }

  private shuffle<T>(arr: T[]): T[] {
    const a = [...arr];
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }
}
